import { useState, type FormEvent } from "react";
import { useBuzz } from "../lib/BuzzProvider";
import { shortPubkey } from "../lib/identity";

export function SettingsPage() {
  const { identity, resetIdentity, importSecret } = useBuzz();
  const [secret, setSecret] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  const onImport = (event: FormEvent) => {
    event.preventDefault();
    setError(null);
    try {
      importSecret(secret);
      setSecret("");
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  };

  const copyPubkey = async () => {
    await navigator.clipboard.writeText(identity.pubkey);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="page-pad">
      <div className="page-header">
        <div>
          <h1>Identity</h1>
          <p>
            Your Nostr keypair is stored in this browser. Agents on the VPS use separate keys and
            join the same channels as members.
          </p>
        </div>
      </div>

      <div className="grid two">
        <div className="panel stack">
          <h2>Current key</h2>
          <p className="muted mono">{shortPubkey(identity.pubkey)}</p>
          <p className="mono tiny" style={{ wordBreak: "break-all" }}>
            {identity.pubkey}
          </p>
          <div className="row">
            <button className="btn" type="button" onClick={() => void copyPubkey()}>
              {copied ? "Copied" : "Copy pubkey"}
            </button>
            <button
              className="btn"
              type="button"
              onClick={() => {
                if (confirm("Generate a new key? You will leave channels until rejoined.")) {
                  resetIdentity();
                }
              }}
            >
              New identity
            </button>
          </div>
          <p className="muted">
            If the relay has an allowlist, add this pubkey on the VPS before chatting.
          </p>
        </div>

        <form className="panel stack" onSubmit={onImport}>
          <h2>Import secret key</h2>
          <p className="muted">64-char hex nsec material (hex only — do not paste into chat).</p>
          <label className="field">
            Secret key hex
            <input
              value={secret}
              onChange={(e) => setSecret(e.target.value)}
              placeholder="hex…"
              autoComplete="off"
              spellCheck={false}
            />
          </label>
          {error ? <p className="error">{error}</p> : null}
          <button className="btn primary" type="submit">
            Import
          </button>
        </form>
      </div>
    </div>
  );
}
